<template lang="html">
  <div id="company-page">

    <section class="main-section">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-7 col-xl-6 col-text">
            <h1 class="mb-2 title">XV Shopping</h1>

            <!-- <h5 class="subtitle"></h5> -->
            <p>
              En XV Shopping, entendemos que cada celebración es única y especial. Nos dedicamos a ofrecerte la mejor selección de ropa y accesorios para fiestas de XV años, bautizos y eventos especiales, ayudándote a encontrar el look perfecto para cada ocasión.
            </p>

            <p class="mt-4">
              Nuestra tienda cuenta con una amplia variedad de vestidos elegantes, trajes, accesorios, calzado y complementos que destacan por su calidad, diseño y exclusividad. Trabajamos con las mejores marcas y diseñadores para asegurarnos de que cada cliente encuentre el estilo ideal que refleje su personalidad y haga brillar su evento.
            </p>
          </div>
        </div>
      </div>
    </section>

    <ExperienceComponent></ExperienceComponent>

  </div>
</template>

<script>
import ExperienceComponent from './experience-component.vue';
export default {
  components: {
    ExperienceComponent
  },

  data() {
    return {
      testimonials: [
        { imageUrl: '', name: 'María Gutiérrez', company: 'Zapatería Calzada', comments: `Empaques Tonalá ha sido mi aliado desde que inicié mi pequeño negocio. La calidad de sus productos es insuperable, pero lo que realmente me ha conquistado es el compromiso humano de su equipo. Me siento respaldada y comprendida en cada paso. Mis productos no solo están bien protegidos, ¡están envueltos en la pasión que solo ellos pueden ofrecer!` },
        { imageUrl: '', name: 'Juan Carlos Rodríguez', company: 'Director RPM Alimentos', comments: 'Trabajar con Empaques Tonalá ha sido clave para optimizar nuestra cadena de suministro. Su compromiso con la eficiencia y la calidad ha elevado nuestros estándares. La flota de distribución es puntual y confiable, y el equipo siempre está dispuesto a adaptarse a nuestras necesidades cambiantes. ¡Una asociación que ha marcado la diferencia en nuestra logística!' },
        { imageUrl: '', name: 'Ana Verástegui', company: 'Diseñadora', comments: 'Como diseñadora, busco empaques que no solo protejan, sino que también comuniquen la esencia de la marca. Empaques Tonalá no solo entiende mi visión, la potencia. Cada diseño es una obra maestra que resalta en los estantes. Trabajar con ellos ha llevado mis proyectos a un nivel que nunca imaginé.' },
        { imageUrl: '', name: 'Ricardo Martínez', company: 'PNP Logistics', comments: `La variedad de productos de Empaques Tonalá ha sido clave para nuestra estrategia de compras. Su amplio stock y la constante introducción de innovaciones nos permite mantenernos a la vanguardia. No solo son proveedores, son socios estratégicos que nos ayudan a enfrentar los desafíos cambiantes del mercado.` },
      ],

      // == Carousels options ==
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        autoHeight: true, //enable auto height
        loopedSlides: 5, //looped slides should be the same
        slidesPerView: 2,
        spaceBetween: 30,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 0
          },
        }
      },
      // == ==
    }
  }
}
</script>
